// @ts-nocheck
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import loadProductPricingAndInventory from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/LoadProductPricingAndInventory";
import {
    chain,
    DispatchUpdateVariantSelection,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection";
import { addToChainBefore, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const LoadRealTimePricingAndInventory = createChainHandler("LoadRealTimePricingAndInventory", chain, props => {
    const { dispatch, productInfo, selectedProductId: productId, variantSelectionCompleted } = props;

    if (!productInfo || !productId || !variantSelectionCompleted) {
        return;
    }

    dispatch(
        loadProductPricingAndInventory({
            product: getProductState(props.getState(), productId).value,
            productInfosById: { [productId]: productInfo },
        }),
    );
});

addToChainBefore(chain, DispatchUpdateVariantSelection, LoadRealTimePricingAndInventory);
